var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 1280,
    viewBox: "0 0 800 1280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_439)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_220_439)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.832 991.885C742.017 991.399 807.066 966.325 822.917 1015C838.794 1063.76 837.032 1130.3 795.91 1160.92C752.873 1192.98 691.451 1160.93 647.606 1130C602.325 1098.05 570.616 1069.28 589.61 1017.22C606.565 970.743 641.369 992.355 690.832 991.885Z",
    fill: "url(#paint0_linear_220_439)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_220_439)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3909 405.604C-8.11342 370.768 -72.5898 344.256 -50.6351 298.01C-28.6441 251.687 18.3782 204.58 69.2963 210.61C122.586 216.921 145.161 282.416 155.732 335.026C166.649 389.359 169.902 432.045 120.314 456.797C76.0505 478.89 65.6334 439.268 29.3909 405.604Z",
    fill: "url(#paint1_linear_220_439)",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_220_439",
    x: 467.65,
    y: 868.65,
    width: 480.896,
    height: 421.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.175,
    result: "effect1_foregroundBlur_220_439"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_220_439",
    x: -171.435,
    y: 93.7367,
    width: 450.226,
    height: 485.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.175,
    result: "effect1_foregroundBlur_220_439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_439",
    x1: 579.78,
    y1: 1179.2,
    x2: 850.956,
    y2: 1060.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_439",
    x1: 238.811,
    y1: 345.927,
    x2: -39.6704,
    y2: 245.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C4D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1280,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.41c8fc417d1d438c50ebafafe59e0360.svg";
export { ForwardRef as ReactComponent };